import { render } from "./FooterMusic.vue?vue&type=template&id=03fb0a1a"
import script from "./FooterMusic.vue?vue&type=script&lang=js"
export * from "./FooterMusic.vue?vue&type=script&lang=js"

import "./FooterMusic.vue?vue&type=style&index=0&id=03fb0a1a&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__